import React, { useEffect } from 'react';
import CenterPanel from './centerPanel';
import BottomLogo from '../../../shared/bottom-logo/content.js';
import AccordionSession from './accordion';
import RightPanelOrTopPanel from './rightPanelOrTopPanel';
import PageHeader from '../../header';
import ProfileContent from 'components/pages/user/profile/content';
import MyRolesPage from '../../../../containers/MyRolesPage';
import ManageInvitations from '../../../../containers/ManageInvitationsContainer';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import { hideWhenClickAwayOrResize } from '../../../shared/contextualMenu/content';
import { resetAllUsersSearchForm, updateAllUsersSearchBar } from 'actions/user';
import ScrollToTopButton from '../../../shared/scrollToTopBtn/content';
import { updateFilterValue } from 'actions/organisation';

export default function AllUsersLisingPage(props) {
  useEffect(() => {
    props.dispatch(updateFilterValue(1));
    window.$('body').click(hideWhenClickAwayOrResize.bind(this, '.waiting-area-view-one'));
    window.$(window).resize(hideWhenClickAwayOrResize.bind(this, '.waiting-area-view-one'));
    return () => {
      window.$('body').unbind('click', hideWhenClickAwayOrResize.bind(this, '.waiting-area-view-one'));
      window.$(window).unbind('resize', hideWhenClickAwayOrResize.bind(this, '.waiting-area-view-one'));
      props.dispatch(resetAllUsersSearchForm());
      props.dispatch(updateAllUsersSearchBar(''));
    };
  }, []);

  const bottomSession = <AccordionSession userId={props.userId} />;

  const modals = (
    <div>
      {props.showOtherUsersProfileModal ? (
        <ProfileContent
          updateOrView="view"
          isAdmin={props.isAdmin}
          selectedUser={props.selectedUser}
          userCallsDetails={props.userCallsDetails}
          showOtherUsersProfileModal={props.showOtherUsersProfileModal}
        />
      ) : (
        ''
      )}
      {props.showOtherUsersRolesModal ? <MyRolesPage selectedUser={props.selectedUser} isViewingOthers={true} /> : ''}
      {props.showManageInvitationsModal ? (
        <ManageInvitations selectedUser={props.selectedUser} timezone={props.timezone} />
      ) : (
        ''
      )}
    </div>
  );
  return (
    <div>
      <div className="main-ui-container manage-users-all-container waiting-area-view-one new-waiting-area-view-one">
        <Container fluid as={Media} greaterThanOrEqual="computer" className="row">
          <div className="left-hand-side-panel">
            <div className="relative">
              <PageHeader
                title={APP.LANGUAGE.ManageAllUsers.Title}
                titleColor="color-primary-dark-grey"
                notRenderLogo={true}
              >
                <span>
                  <img
                    className="ui image  mrrnull fl pdrs header-icon"
                    src={APP.IMAGES.UserManagementOrgPageIcon.default}
                  />
                </span>
              </PageHeader>
            </div>
            <div className="pdlm pdrm">
              <CenterPanel
                timezone={props.timezone}
                isOnMobileOrTablet={false}
                usersIcanManageForAdmin={props.usersIcanManageForAdmin}
                allUsersSearchForm={props.allUsersSearchForm}
                searchPageSize={props.searchPageSize}
                dispatch={props.dispatch}
              />
            </div>
          </div>

          <div className="right-hand-side-panel color-right-hand-side-panel-bg">
            <RightPanelOrTopPanel
              allUsersSearchForm={props.allUsersSearchForm}
              dispatch={props.dispatch}
              bottomSession={bottomSession}
            />
          </div>
        </Container>
        <Container fluid as={Media} lessThan="computer">
          <div className="left-hand-side-panel-mobile">
            <PageHeader
              title={APP.LANGUAGE.ManageAllUsers.Title}
              titleColor="color-primary-dark-grey"
              notRenderLogo={true}
            >
              <span>
                <img
                  className="ui image  mrrnull fl pdrs header-icon"
                  src={APP.IMAGES.UserManagementOrgPageIcon.default}
                />
              </span>
            </PageHeader>
            {!!props.allUsersSearchForm.numberOfAllUsers ? (
              !!props.allUsersSearchForm.totalRowsForSet ? (
                <div className="pdbm pdrm pdlxs mrlxs bold" style={{ marginTop: '-15px' }}>
                  {APP.LANGUAGE.ManageAllUsers.NumberOfUsers}
                  {props.allUsersSearchForm.totalRowsForSet +
                    APP.LANGUAGE.ManageAllUsers.TotalNumberOf +
                    props.allUsersSearchForm.numberOfAllUsers}
                </div>
              ) : (
                <div className="pdbm pdrm pdlxs mrlxs bold" style={{ marginTop: '-15px' }}>
                  {APP.LANGUAGE.ManageAllUsers.NumberOfUsers}
                  {APP.LANGUAGE.ManageAllUsers.ZeroNumberOf + props.allUsersSearchForm.numberOfAllUsers}
                </div>
              )
            ) : (
              ''
            )}
            <div>
              <CenterPanel
                timezone={props.timezone}
                isOnMobileOrTablet={true}
                usersIcanManageForAdmin={props.usersIcanManageForAdmin}
                allUsersSearchForm={props.allUsersSearchForm}
                searchPageSize={props.searchPageSize}
                dispatch={props.dispatch}
              />
            </div>
            <div className="mrtl right-hand-side-bottom-on-mobile">
              {bottomSession}
              <BottomLogo />
            </div>
          </div>
        </Container>
        {modals}
      </div>
      <Container as={Media} lessThan="computer">
        <ScrollToTopButton className="scroll-top-btn-desktop" />
      </Container>
    </div>
  );
}
